// interface Message {
//   system_user: string;
// }

interface MessageComponentProps {
  message: string;
}

const MessageComponent = ({ message }: MessageComponentProps) => {
  // Function to parse and convert URLs into anchor tags
  const parseMessage = (text: string): JSX.Element[] => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split("\n").map((part, index) => {
      // Replace URLs with anchor tags
      const newPart = part.replace(urlRegex, (url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-brand-500 underline">${url}</a>`;
      });

      return (
        <span key={index} className="break-words">
          <span dangerouslySetInnerHTML={{ __html: newPart }} />
          <br />
        </span>
      );
    });

    return parts;
  };

  return (
    <span className="text-body font-body text-default-font break-words">
      {parseMessage(message)}
    </span>
  );
};

export default MessageComponent;
